import { MeasurementUnitModel } from '@msdk/definitions'

export const getTranslatedMu = (
  key: string | null | undefined,
  mus: MeasurementUnitModel[] | null | undefined,
): string => {
  return mus?.find((u) => u.key === key)?.tDescription ?? key ?? ''
}
